import React, { useContext, useEffect } from 'react';
import { DataContext } from '../../data/DataContext';
import { DropDown, Input } from "../controls";
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';
import { origenFondo, monedas } from '../../data/MochaData';

const Step3 = () => {
    const { VivirSeguro, setVivirSeguro, changeHandler, init } = useContext(DataContext);

    useEffect(() => {
        http(endPoints.economicActivities(0)).get()
            .then(data => {
                VivirSeguro.setCatalogos({ actividadEconomica: data });
            });
    }, [init]);

    const loadActividadEconomica = () => {
        http(endPoints.economicActivities(0)).get()
            .then(data => {
                VivirSeguro.setCatalogos({ actividadEconomica: data });
            });

    }

    const pIngreso = "^(?!0|\.00)[0-9]+(,\d{3})*(.[0-9]{0,2})$";
    // pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999'

    return (
        <div className="step">
            <div className="step-container-vivirseguro">
                <div>
                    <span className="title2">Actividad Econ&oacute;mica</span>
                </div>
                <div>
                    <span className="title3">¡Queremos conocerte! Ingres&aacute; los siguientes datos, seg&uacute;n tu documento de identidad</span>
                </div>
                <DropDown containBlank={false} isrequired={true} label="Actividad ecónomica" dataProvider={VivirSeguro.catalogos.actividadEconomica} valueSelect={VivirSeguro.actividadEconomica} fieldSelect="actividadEconomica" field="actividadEconomica" isRequired={true} onChangeSelect={changeHandler} />
                <Input label="Empresa donde trabaja" value={VivirSeguro.empresaTrabaja} field="empresaTrabaja" onChange={changeHandler} />
                <Input label="Teléfono de la empresa" type='mask' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' mask='9999-9999' value={VivirSeguro.telefonoEmpresa} field="telefonoEmpresa" onChange={changeHandler} />
                <Input label="Ocupación Actual" value={VivirSeguro.ocupacionActual} field="ocupacionActual" onChange={changeHandler} />
                <DropDown isrequired={true} label="Moneda de ingresos mensuales" dataProvider={monedas} valueSelect={VivirSeguro.monedaIngreso} fieldSelect="monedaIngreso" field="monedaIngreso" isRequired={true} onChangeSelect={changeHandler} />
                <Input label="Indique el monto de sus ingresos mensuales" value={VivirSeguro.montoIngreso} field="montoIngreso" onChange={changeHandler}  type="number"  />
                <DropDown isrequired={true} label="Origen de los fondos" dataProvider={origenFondo} valueSelect={VivirSeguro.origenFondo} fieldSelect="origenFondo" field="origenFondo" isRequired={true} onChangeSelect={changeHandler} />
            </div>
        </div>
    );

}
export default Step3;